import { useCallback, useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { orgUrlSegment } from "../orgRouting";
import { prefetchComplianceOverview } from "../state/complianceOverviewPrefetch";

/** Warm only the active directory-verified org, after paint or on navigation intent. */
export function useComplianceOverviewPrefetch(organizationId: string | null) {
  const router = useRouter();
  const prefetch = useCallback(() => {
    if (!organizationId) return;
    prefetchComplianceOverview(organizationId);
    // Page code and data start together; speculative failure must not disrupt navigation.
    void router
      .preloadRoute({
        to: "/$org/compliance",
        params: { org: orgUrlSegment(organizationId) },
      })
      .catch(() => undefined);
  }, [organizationId, router]);

  useEffect(() => {
    if (!organizationId) return;
    if (typeof window.requestIdleCallback === "function") {
      const idle = window.requestIdleCallback(prefetch, { timeout: 1000 });
      return () => window.cancelIdleCallback(idle);
    }
    const timer = window.setTimeout(prefetch, 250);
    return () => window.clearTimeout(timer);
  }, [organizationId, prefetch]);

  return prefetch;
}
